import { DataSourceExecutionEvent, ClickEvent } from "@mcleod/components";
import { AutogenLayoutDriverEvents } from "./autogen/AutogenLayoutDriverEvents";
import { DateFormat, DateUtil, ModelRow, Navigation, UrlUtil } from "@mcleod/core";

export class DriverEvents extends AutogenLayoutDriverEvents {
    sourceDriverEventsAfterExecution(event: DataSourceExecutionEvent) {
        let title = "Driver Events";
        const response: ModelRow = event.dataSource?.data?.[0];
        if (response.getNumber("approved_seven", 0) == 0 &&
            response.getNumber("approved_thirty", 0) == 0 &&
            response.getNumber("unapproved_seven", 0) == 0 &&
            response.getNumber("unapproved_thirty", 0) == 0) {
            title = "No Driver Events"
        }
        this.title = title;
    }

    /** This is an event handler for the onClick event of labelUnapproved30Count. */
    labelUnapproved30CountOnClick(event: ClickEvent) {
        this.navigateToEventsList("U30");
    }

    /** This is an event handler for the onClick event of labelUnapproved7Count. */
    labelUnapproved7CountOnClick(event: ClickEvent) {
        this.navigateToEventsList("U7");
    }

    /** This is an event handler for the onClick event of labelApproved30Count. */
    labelApproved30CountOnClick(event: ClickEvent) {
        this.navigateToEventsList("A30");
    }

    /** This is an event handler for the onClick event of labelApproved7Count. */
    labelApproved7CountOnClick(event: ClickEvent) {
        this.navigateToEventsList("A7");
    }

    /** This is an event handler for the onClick event of labelTotalEvents. */
    labelTotalEventsOnClick(event: ClickEvent) {
        this.navigateToEventsList("T");
    }

    private navigateToEventsList(status:string) {
        const urlParams: string[] = [];
        if(status != null) urlParams.push("status="+status);
        Navigation.navigateTo("lme/dispatch/DriverEventsList" + UrlUtil.buildQueryString(urlParams));
    }
}
